export default __webpack_public_path__ + "19592b1f14c2d6883df34b70be4725c8.otf";